module.exports = __webpack_public_path__ + "pindao_tpl_v0_0_2\\static\\img\\yuyue_icon.svg";